<template>
  <div :class="classNames()">
      <h3 class="txt-lh42 txt-ellipsis">{{address.name}}</h3>
      <p class="txt-lh28 pt15 txt-two-ellipsis">{{address.address}}</p>
      <p class="txt-lh24 mt15 plr25 area">{{address.distanceMsg || ''}}</p>
  </div>
</template>
<style lang="less" src="./AddressCard.less">
</style>
<script>
export default {
  name: 'AddressCard',
  props: {
    selected: {
      type: Boolean,
      default(){
        return false
      }
    },
    address: {
      type: Object,
      default(){
        return {}
      }
    }
  },
  methods: {
    classNames() {
      return ["address-card", {selected: this.selected}]
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/courseCenter/newsign/AddressCard.vue